<template lang="html">
  <v-snackbar v-model="showError" top color="error">
    <div v-html="errorMessage" />
    <v-btn color="white" text @click="removeErrors">
      Close
    </v-btn>
  </v-snackbar>
</template>

<script>
export default {
  computed: {
    errorType: function() {
      const value = this.$store.getters.errorType
      if (value !== undefined && value !== null) {
        return this.$store.getters.errorType
      } else {
        return ''
      }
    },
    errorMessage: function() {
      const value = this.$store.getters.errorMessage
      if (value !== undefined && value !== null) {
        return this.$store.getters.errorMessage
      } else {
        return ''
      }
    },
    showError: function() {
      const value = this.$store.getters.showError
      if (value !== undefined && value !== null) {
        return true
      } else {
        return false
      }
    }
  },
  mounted() {
    setTimeout(this.removeErrors, 5000)
  },
  methods: {
    removeErrors() {
      this.$store.dispatch('removeErrors')
    }
  }
}
</script>
